/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function ($) {
  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    common: {
      init: function () {
        $(".watch-video-wrap a").magnificPopup({ type: "iframe" });

        // Scroll animation
        $("#hero-header .scroll-down").click(function (e) {
          e.preventDefault();
          $([document.documentElement, document.body]).animate(
            {
              scrollTop:
                $("#hero-header").offset().top +
                $("#hero-header").height() -
                70,
            },
            600
          );
        });

        $("#hero-header .scroll-bottom").click(function (e) {
          e.preventDefault();
          $([document.documentElement, document.body]).animate(
            {
              scrollTop: $(document).height(),
            },
            800
          );
        });

        // Toggle sidebar
        $(document).ready(function () {
          $sidebar = $("#menu-sidebar");
          $sidebar.css("right", -$sidebar.width());
          $body = $("body");

          $("#dismiss a, .menu-overlay").on("click", function (e) {
            e.preventDefault();
            $sidebar.css("right", -$sidebar.width());
            $body.css("overflow", "auto");
            $(".menu-overlay").fadeOut();
          });

          $("#openSidebar").on("click", function (e) {
            e.preventDefault();
            $sidebar.css("right", 0);
            $body.css("overflow", "hidden");
            $(".menu-overlay").fadeIn();
          });
        });

        // JavaScript to be fired on all pages
        $(".es-field-wrap input[name='name']").attr("placeholder", "full name");
        $(".es-field-wrap input[name='email']").attr(
          "placeholder",
          "email address"
        );

        //pop up images
        $(".infographic-wrap a").magnificPopup({
          type: "image",
          image: {
            verticalFit: false,
          },
        });

        //Email subscribe box close cookie
        $(".close").click(function (e) {
          // Do not perform default action when button is clicked
          e.preventDefault();
          /* If you just want the cookie for a session don't provide an expires
           Set the path as root, so the cookie will be valid across the whole site */
          $.cookie("subscribe-box", "closed", { path: "/" });
        });

        // Check if alert has been closed
        if ($.cookie("subscribe-box") === "closed") {
          $("#subscribe-box").hide();
        }

        // Remove empty p tags
        $("p:empty").remove();
        $("p > .event-link").remove();

        // Toggle publications hidden content
        $(".publication a.toggle").click(function (e) {
          e.preventDefault();
          var target = $(this).data("target");
          var publicationBlock = $(this).closest(".publications-block");
          var publication = $(this).closest(".publication");
          publicationBlock
            .find(".collapsible-publication-content")
            .each(function () {
              if ("#" + $(this).attr("id") !== target) {
                $(this).hide();
              }
            });
          publicationBlock.find(".publication").each(function () {
            if ($(this).find("a.toggle").data("target") !== target) {
              $(this).removeClass("active");
            }
          });
          publicationBlock.find(target).toggle();
          publication.toggleClass("active");
        });

        // Share links
        $(".share-link.toggle").click(function (e) {
          e.preventDefault();
          $(this).find("i").toggleClass("fa-share-alt fa-chevron-right");
          $(this).closest(".share-links").find(".collapsible-icons").animate({
            width: "toggle",
          });
        });

        // Set cookie when download bar is closed
        if (document.cookie.indexOf("download") === -1) {
          $("#close").click(function () {
            var now = new Date();

            if (document.cookie.indexOf("clicked") === -1) {
              var expiryDate1 = now.setTime(now.getTime() + 120 * 1000);
              now.setTime(expiryDate1);
              document.cookie =
                "download=true;expires=" + now.toGMTString() + ";path=/";

              // Create a new cookie to check if the user has clsoed the banner before
              var expiryDateClicks = now.setTime(
                now.getTime() + 24 * 60 * 60 * 1000
              );
              now.setTime(expiryDateClicks);
              document.cookie =
                "clicked=true;expires=" + now.toGMTString() + ";path=/";
            } else {
              // If user has closed the banner before set expiry time to 24 hours
              var expiryDate2 = now.setTime(
                now.getTime() + 24 * 60 * 60 * 1000
              );
              now.setTime(expiryDate2);
              document.cookie =
                "download=true;expires=" + now.toGMTString() + ";path=/";
            }

            $("#download-bar").remove();
          });
        }

        function openBannerPopup() {
          $.magnificPopup.open({
            items: {
              src: "#popup-banner",
            },
            type: "inline",
            callbacks: {
              close: function () {
                if (document.cookie.indexOf("banner") === -1) {
                  var now = new Date();
                  var expiry = now.setTime(now.getTime() + 24 * 60 * 60 * 1000);
                  now.setTime(expiry);
                  document.cookie =
                    "banner=true;expires=" + now.toGMTString() + ";path=/";
                }
              },
              open: function () {
                $("html").css("overflow", "scroll");
              },
            },
          });
        }

        if (document.cookie.indexOf("banner") === -1) {
          if ($("#popup-banner").hasClass("auto")) {
            openBannerPopup();
          }
        }

        $("#offers").on("click", function () {
          openBannerPopup();
        });

        /** Sets Cookie on dismiss */
        $("#dismiss i").on("click", function () {
          if (document.cookie.indexOf("banner") === -1) {
            var now = new Date();
            var expiry = now.setTime(now.getTime() + 24 * 60 * 60 * 1000);
            now.setTime(expiry);
            document.cookie =
              "banner=true;expires=" + now.toGMTString() + ";path=/";
          }
          $.magnificPopup.close();
        });

        /** Sets Cookie when call to action is clicked */
        $(".popup-banner-inner .btn").on("click", function (e) {
          e.preventDefault();

          if (document.cookie.indexOf("banner") === -1) {
            var now = new Date();
            var expiry = now.setTime(now.getTime() + 24 * 60 * 60 * 1000);
            now.setTime(expiry);
            document.cookie =
              "banner=true;expires=" + now.toGMTString() + ";path=/";
          }

          var link = $(this).attr("href");

          window.location.href = link;
        });
      },
      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired
      },
    },
    // Home page
    home: {
      init: function () {
        $(".watch-video-wrap a").magnificPopup({ type: "iframe" });

        $(".testimonial-slider .slides").slick({
          slidesToShow: 6,
          arrows: false,
          dots: true,
          adaptiveHeight: true,
          infinite: false,
          nextArrow:
            '<a href="#" class="slick-next"><i class="fa fa-angle-right"></i></a>',
          prevArrow:
            '<a href="#" class="slick-prev"><i class="fa fa-angle-left"></i></a>',
          responsive: [
            {
              breakpoint: 2000,
              settings: {
                slidesToShow: 4,
              },
            },
            {
              breakpoint: 1200,
              settings: {
                slidesToShow: 3,
              },
            },
            {
              breakpoint: 991,
              settings: {
                slidesToShow: 2,
              },
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1,
              },
            },
          ],
        });
      },
      finalize: function () {
        // JavaScript to be fired on the home page, after the init JS

        $(document).ready(function () {
          $(".popup-modal").magnificPopup({
            type: "inline",
            preloader: false,
            focus: "#username",
            modal: true,
          });
          // $(document).on("click", ".popup-modal-dismiss", function (e) {
          //   e.preventDefault();
          //   $.magnificPopup.close();
          // });
        });
      },
    },
    meditate: {
      init: function () {
        //Set up mp3 players
        $(".mp3player").each(function () {
          var mp3player = $(this);
          var cuetype = $(this).attr("id");
          var playButton = $(this).find("#play");
          var pauseButton = $(this).find("#pause");
          var progressBar = $(this).find("#seekbar");
          var player = $(this).find("#player");
          var durationStart = $(this).find(".startime");
          var durationEnd = $(this).find(".endtime");
          //timing function
          function formatTime(seconds) {
            minutes = Math.floor(seconds / 60);
            minutes = minutes >= 10 ? minutes : "0" + minutes;
            seconds = Math.floor(seconds % 60);
            seconds = seconds >= 10 ? seconds : "0" + seconds;
            return minutes + ":" + seconds;
          }
          $(playButton).on("click", function () {
            $(player).get(0).play();
            $(this).hide();
            $(pauseButton).show();
            $(durationEnd).html(formatTime(player.get(0).duration));
          });
          $(pauseButton).on("click", function () {
            $(player).get(0).pause();
            $(this).hide();
            $(playButton).show();
          });
          $(player).on("timeupdate", function () {
            $(progressBar).attr("value", this.currentTime / this.duration);
          });
          $("player").on("timeupdate", function () {
            $(durationStart).html(formatTime(this.currentTime));
          });
        });
      },
      finalize: function () {
        // JavaScript to be fired on the meditate page, after the init JS\

        var animated = Array.from(document.getElementsByClassName("animated"));

        for (var i = 0; i < animated.length; i++) {
          if (animated[i].cx !== undefined) {
            var x = animated[i].cx.animVal.value;
            var y = animated[i].cy.animVal.value;
            animated[i].style.transformOrigin = x + "px " + y + "px";
          } else {
            var bb = animated[i].getBBox();
            animated[i].style.transformOrigin =
              bb.x + bb.width / 2 + "px " + (bb.y + bb.height / 2) + "px";
          }
        }

        //HEADER IMAGE
        anime({
          targets: "#headphone-lead",
          d: [
            {
              value:
                "M312.2,481c0,0-32.1,53.7-9.2,62c18,6.5,52-11,30.3-28.5c-5.8-4.7-13.5-13.5-64.5,22.5s-5.8-51-5.8-51",
            },
          ],
          easing: "easeInOutSine",
          duration: 8000,
          direction: "alternate",
          loop: true,
        });
        anime({
          targets: "#person",
          translateY: [
            { value: 30, duration: 2000 },
            { value: 0, duration: 2000 },
          ],
          easing: "easeInOutSine",
          loop: true,
        });
        anime({
          targets: "#headphones_1",
          translateY: [
            { value: 30, duration: 6000 },
            { value: 0, duration: 6000 },
          ],
          easing: "easeInOutSine",
          loop: true,
        });
        anime({
          targets: "#shadow",
          scale: [
            { value: [0.8, 1], duration: 2000 },
            { value: [1, 0.8], duration: 2000 },
          ],
          easing: "easeInOutSine",
          loop: true,
        });
        anime({
          targets: "#phone",
          rotate: [{ value: 360, duration: 20000 }],
          easing: "easeInOutSine",
          loop: true,
        });
        anime({
          targets: ".pen",
          rotate: [{ value: 360, duration: 10000 }],
          translateY: [
            { value: 30, duration: 2000 },
            { value: 0, duration: 2000 },
          ],
          easing: "easeInOutSine",
          loop: true,
        });
        anime({
          targets: "#briefcase",
          translateY: [
            { value: 20, duration: 4000 },
            { value: 0, duration: 4000 },
          ],
          rotate: [
            { value: 20, duration: 3000 },
            { value: -1, duration: 4000 },
          ],
          easing: "easeInOutSine",
          loop: true,
        });
        anime({
          targets: "#chart",
          rotate: [{ value: 360, duration: 50000 }],
          easing: "easeInOutSine",
          loop: true,
        });
        //breathing man
        anime({
          targets: "#outer-point",
          scale: [{ value: [0, 1], duration: 3000 }],
          opacity: [
            { value: 0, duration: 450 },
            { value: 1, duration: 1500 },
            { value: 0, duration: 2000 },
          ],
          easing: "easeOutExpo",
          loop: true,
        });
        //Waving girl
        anime({
          targets: "#right-cloud",
          translateX: [
            { value: 30, duration: 4000 },
            { value: 0, duration: 4000 },
          ],
          easing: "linear",
          loop: true,
        });
        anime({
          targets: "#left-cloud",
          translateX: [
            { value: -30, duration: 6000 },
            { value: 0, duration: 6000 },
          ],
          easing: "linear",
          loop: true,
        });
        //posture scene
        anime({
          targets: "#twinkle",
          scale: [{ value: [0, 1], duration: 3000 }],
          opacity: [
            { value: 1, duration: 1000 },
            { value: 0, duration: 2000 },
          ],
          easing: "easeOutExpo",
          loop: true,
        });
        anime({
          targets: "#twinkle_1",
          scale: [{ value: [0, 1], duration: 3000 }],
          opacity: [
            { value: 1, duration: 1000 },
            { value: 0, duration: 2000 },
          ],
          easing: "easeOutExpo",
          loop: true,
          delay: 1000,
        });
        anime({
          targets: "#twinkle_2",
          scale: [{ value: [0, 1], duration: 3000 }],
          opacity: [
            { value: 1, duration: 1000 },
            { value: 0, duration: 2000 },
          ],
          easing: "easeOutExpo",
          loop: true,
          delay: 500,
        });
        //sitting woman
        anime({
          targets: "#right-ying",
          rotate: [{ value: 360, duration: 4000 }],
          scale: [
            { value: [0.7, 1], duration: 2000 },
            { value: [1, 0.7], duration: 2000 },
          ],
          easing: "linear",
          loop: true,
        });
        anime({
          targets: "#left-yang",
          rotate: [{ value: 360, duration: 4000 }],
          scale: [
            { value: [0.7, 1], duration: 2000 },
            { value: [1, 0.7], duration: 2000 },
          ],
          easing: "linear",
          loop: true,
        });
      },
    },
    // About us page, note the change from about-us to about_us.
    about_us: {
      init: function () {
        // JavaScript to be fired on the about us page
      },
    },
    blog: {
      init: function () {
        // JavaScript to be fired on the blog page
        //Scrolling
        var distance = $("#subscribe-box").length
            ? $("#subscribe-box").offset().top
            : 0,
          $window = $(window);

        $window.scroll(function () {
          if ($window.scrollTop() >= distance && distance !== 0) {
            //Your div has reached the top
            $("#subscribe-box").addClass("fixed-box");
            $(".wrap").addClass("margin-sub");
          } else {
            $("#subscribe-box").removeClass("fixed-box");
            $(".wrap").removeClass("margin-sub");
          }
        });
        //Scrolling end
      },
    },
    single: {
      init: function () {
        // JavaScript to be fired on the blog page

        //Scrolling
        var distance = $("#subscribe-box").length
          ? $("#subscribe-box").offset().top
          : 0;

        $window = $(window);

        $window.scroll(function () {
          if ($window.scrollTop() >= distance && distance !== 0) {
            //Your div has reached the top
            $("#subscribe-box").addClass("fixed-box");
            $(".wrap").addClass("margin-sub");
          } else {
            $("#subscribe-box").removeClass("fixed-box");
            $(".wrap").removeClass("margin-sub");
          }
        });
        //Scrolling end
      },
    },
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function (func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = funcname === undefined ? "init" : funcname;
      fire = func !== "";
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === "function";

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function () {
      // Fire common init JS
      UTIL.fire("common");

      // Fire page-specific init JS, and then finalize JS
      $.each(
        document.body.className.replace(/-/g, "_").split(/\s+/),
        function (i, classnm) {
          UTIL.fire(classnm);
          UTIL.fire(classnm, "finalize");
        }
      );

      // Fire common finalize JS
      UTIL.fire("common", "finalize");
    },
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);
})(jQuery); // Fully reference jQuery after this point.
